<template>
  <div class="lb">
    <div ref="barMian" class="barMian" @mouseover="autoTimePaused = true" @mouseout="autoTimePaused = false"></div>
  </div>
</template>

<script>
import * as methods from './method.js'
export default {
  name: 'template.scope41',
  props: {
    vdata: {
      type: [Array, String],
      default: () => []
    },
    jsondata: {
      type: [Array, String],
      default: () => []
    },
    scopedata: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      title: '基本堆叠水平条形图-scope41',
      timer: null,
      defaultdata: [
        { value1: '1月', value2: '80', value3: '系列一', value4: '60', value5: '系列二', value6: '元' },
        { value1: '2月', value2: '40', value3: '系列一', value4: '40', value5: '系列二' },
        { value1: '3月', value2: '62', value3: '系列一', value4: '70', value5: '系列二' },
        { value1: '4月', value2: '90', value3: '系列一', value4: '20', value5: '系列二' },
        { value1: '5月', value2: '88', value3: '系列一', value4: '36', value5: '系列二' },
        { value1: '6月', value2: '75', value3: '系列一', value4: '52', value5: '系列二' },
      ],
      valueMap: [
        { name: '名称', key: "value1" },
        { name: '柱状图数值1', key: "value2" },
        { name: '柱状图图例1', key: 'value3' },
        { name: '柱状图数值2', key: "value4" },
        { name: '柱状图图例2', key: 'value5' },
        { name: '单位', key: 'value6' }
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
      autoTimePaused: false,
    }
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        let vdatalist = n.filter(item => {
          let vlist = Object.keys(item)
          let isdata = false
          vlist.forEach(del => {
            if (item[del] == undefined) {
              item[del] = ''
            } else if (del && item[del]) {
              isdata = true
            }
          })
          if (vlist.length && isdata) return item
        })
        this.defaultdata = vdatalist
      }
    },
    jsondata(n) {
      this.exceldata = n
    },
    defaultdata(n) {
      this.DrawEcharts()
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null
  },
  methods: {
    ...methods,
    DrawEcharts() {
      clearInterval(this.timer);
      this.timer = null;
      var echarts = require("echarts");
      var TmyChart = echarts.init(this.$refs.barMian);
      let data1 = [];
      let data2 = [];
      let legend = [];
      let unit = this.defaultdata[0].value6
      this.defaultdata.forEach((item, i) => {
        if (item.value2 && item.value3) {
          const vdata1 = { name: item.value3, value: item.value2 };
          data1.push(vdata1);
        }
        if (item.value4 && item.value5) {
          const vdata2 = { name: item.value5, value: item.value4 };
          data2.push(vdata2);
        }
        if (i == 0) {
          if (item.value3) {
            legend.push({
              top: "2%",
              right: "50%",
              itemHeight: 12, //图例的高度  文字左边那个
              itemWidth: 10,
              textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
              data: [{ name: item.value3, icon: "rect" }],
            });
          }
          if (item.value5) {
            legend.push({
              top: "2%",
              left: "50%",
              itemHeight: 12, //图例的高度  文字左边那个
              itemWidth: 10,
              textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
              data: [{ name: item.value5, icon: "rect" }],
            });
          }
        }
      });
      let yAxis = this.defaultdata.map((item) => item.value1);
      const percent = (5 / yAxis.length) * 100;
      const zoom = [
        {
          id: "scope41", // 唯一的id
          yAxisIndex: [0], //滑动条为竖
          type: 'slider',
          moveHandleSize: 0,
          showDetail: false, //关闭：拖拽时候显示详细数值信息。	
          dataBackground: {
            show: false,
            lineStyle: {
              opacity: 0,
            },
            areaStyle: {
              opacity: 0,
            },
          },
          selectedDataBackground: {
            lineStyle: {
              opacity: 0,
            },
            areaStyle: {
              opacity: 0,
            },
          },
          backgroundColor: "transparent",
          fillerColor: "rgba(0,0,0,.2)",
          borderColor: "transparent",
          start: 0,
          brushSelect: false,
          end: percent
        },
      ];
      var Toption = {
        title: [
          {
            text: unit,
            top: "0",
            left: "0",
            textStyle: {
              color: "#979AA0",
              fontSize: 12,
            },
          },
        ],
        tooltip: {
          // trigger: 'axis'
        },
        legend: [...legend],
        grid: {
          left: "5px",
          right: "10px",
          bottom: "10px",
          top: "30px",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "rgba(231,241,251,.2)",
            },
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
            },
          },
        },
        yAxis: {
          type: "category",
          z: 10,
          data: yAxis,
          axisLabel: {
            interval: 0,
            width: 54,
            overflow: "truncate", //文字超出宽度截断，默认为...
            // overflow: 'break', //文字超出宽度截断 换行
            textStyle: {
              color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
              fontSize: "14",
              lineHeight: 16,
            },
            // formatter: function (value) {
            // 		return value.length > 6 ? value.slice(0, 5) + '...' : value;
            // }
          },
          axisLine: {
            lineStyle: {
              // X 轴颜色配置
              color: "#4792e9",
            },
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            name: this.defaultdata[0].value3 || "",
            type: "bar",
            stack: "total",
            barWidth: 15,
            barGap: "40%",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  1,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#0182fc", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#0b3b6c", // 100% 处的颜色
                    },
                  ],
                  false
                ),
              },
            },
            data: data1,
          },

          {
            name: this.defaultdata[0].value5 || "",
            type: "bar",
            stack: "total",
            barWidth: 15,
            barGap: "40%",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  1,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#00e3e2", // 0% 处的颜色
                    },
                    // {
                    //   offset: 0.6,
                    //   color: "#00e3e2" // 0% 处的颜色
                    // },
                    {
                      offset: 1,
                      color: "#175f62", // 100% 处的颜色
                    },
                  ],
                  false
                ),
              },
            },
            // data: [4, 3, 3, 2, 4, 3, 4]
            data: data2,
          },
        ],
      };
      if (yAxis && yAxis.length > 5) {
        Toption.dataZoom = zoom;
      }
      Toption && TmyChart.setOption(Toption);
      this.timer = setInterval(() => {
        if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
        TmyChart.clear();
        Toption && TmyChart.setOption(Toption);
      }, 5000);
    },
  },
  created() {

  },
  mounted() {
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata
    }
    if (this.jsondata && this.jsondata.length) {
      this.exceldata = this.jsondata
    }
    this.setData()
    this.DrawEcharts(); //需要刷新的数据
  },
}
</script>

<style scoped>
.lb {
  width: 435px;
  height: 240px;
  display: flex;
  overflow: hidden;
  position: relative;
  padding: 10px 0;
}

.barMian {
  width: 100%;
  height: 100%;
}
</style>